import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Carousel extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
  }

  state = {
    current: 1,
    width: 0,
  }

  container = null

  componentDidMount () {
    window.addEventListener('resize', this.recalculateSize)
    this.recalculateSize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.recalculateSize)
  }

  storeContainerRef = (ref) => {
    this.container = ref
  }

  recalculateSize = () => this.setState({
    width: this.container ? this.container.offsetWidth : 0,
  })

  previous = () => {
    this.setState(
      (state) => ({ current: state.current === 1 ? this.props.children.length : state.current - 1 })
    )
  }

  next = () => {
    this.setState(
      (state) => ({ current: state.current === this.props.children.length ? 1 : state.current + 1 })
    )
  }

  handleCarouselClick = () => this.props.onClick && this.props.onClick()

  render () {
    const { current, width } = this.state

    const outerWrapperStyle = {
      height: width / 1.5,
    }

    const innerWrapperStyle = {
      width: width * this.props.children.length,
      transform: `translateX(${(current - 1) * -width}px)`,
    }

    const imageStyle = { width }

    return (
      <div className='carousel' ref={this.storeContainerRef} style={outerWrapperStyle}>
        <div className='carousel__track' style={innerWrapperStyle} onClick={this.handleCarouselClick}>
          {this.props.children.map((image) => React.cloneElement(image, { style: imageStyle }))}
        </div>
        {(this.props.children.length > 1) && (
          <>
            <button className='carousel__nav carousel__nav--previous' onClick={this.previous}><span className='sr-only'>Previous</span></button>
            <button className='carousel__nav carousel__nav--next' onClick={this.next}><span className='sr-only'>Next</span></button>
          </>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Carousel.js